module.exports = __webpack_public_path__ + "src/assets/textures/env/tractor/engine_compartment_door_4K_bake.png";